

document.addEventListener("DOMContentLoaded", function() {

    console.log('Made with ❤️ by Insight')

    const elMenuOpener = document.querySelector('.menu-opener')
    const elMenu = document.querySelector('.menu')
    const elMain = document.querySelector('main')
    const elMenuCloseIcon = document.querySelector('.burger-menu .close')
    const elMenuOpenIcon = document.querySelector('.burger-menu .open')

    elMenuOpener.addEventListener('click', (e) => {
        e.preventDefault()
        if(elMenu.classList.contains('is-close')) {
            elMenu.classList.remove('is-close')
        }

        elMenu.classList.toggle('is-open')
        elMain.classList.toggle('is-ok')

        if(!elMenu.classList.contains('is-open')) {
            setTimeout(() => {
                elMenu.classList.add('is-close')
            }, 800);
        }
    })
})


function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

$(window).scroll(function () {
    $('article').each(function () {
        if (isScrolledIntoView(this) === true) {
            $(this).addClass('visible');
        }
    });
});

$(window).on('load',function () {
    $('article:first').each(function () {
        $(this).addClass('visible');
    });
});



// load pager

$(document).ready(function() {
    // Fakes the loading setting a timeout
    setTimeout(function() {
        $('body').addClass('loaded');
    }, 1500);

    if(document.querySelector('.page-template-template-petitstudio')) {

        $('.slides-petitstudio').owlCarousel({
            items: 3,
            nav: false,
            autoWidth: true,
            loop: true,
            slideBy: 2,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:3
                },
                1000:{
                    items:3
                }
            }
        });
    }

    if(document.querySelector('.archive')) {

        $('.owl-carousel').owlCarousel({
            items: 5,
            nav: false,
            center: true,
            stagePadding: 100,
            autoWidth: true,
            loop: true,
            margin: 50,

        });

        const elCategory = document.querySelectorAll('.cat-item')

    }

    if(document.querySelector('.archive.category')) {
        const elItemPicture =  document.querySelectorAll('.elem-post')

        elItemPicture.forEach(elemImage => {

            elemImage.addEventListener('click', () => {
                const dataId = elemImage.dataset.idpost

                console.log('jai clicker', dataId)

                localStorage.setItem('idElemClick', dataId)
            })
        })
    }

    if(document.querySelector('.archive.tag')) {

        const idElemToScroll = localStorage.getItem('idElemClick')

        console.log(idElemToScroll)

        if(idElemToScroll) {

            const elToScroll = document.querySelector(`[data-imgpos='${idElemToScroll}']`)

            setTimeout(function(){

                elToScroll.scrollIntoView()
                window.scrollBy(0, -100);

            }, 50);



            //Clear Local Storage
            localStorage.clear()

        }
        // Add ajax on click of category nav

        const elCategoryItemNav = document.querySelectorAll('.cat-item')

        elCategoryItemNav.forEach(elemNav => {
            elemNav.addEventListener('click', (event) => {

                const link = elemNav.querySelector('a').getAttribute('href')

                event.preventDefault()

                $.ajax({
                    url: link,
                    success: function(data) {

                        var pageContent = $(data).find('.content-cat')

                        $('#content-category-page').html(pageContent)

                        document.querySelectorAll('.current-cat').forEach(elem => { elem.classList.remove('current-cat')})

                        elCategoryItemNav.forEach(retrieveElem => {
                            const attrLink = retrieveElem.querySelector('a').getAttribute('href')

                            if (attrLink === link) {

                                retrieveElem.classList.add('current-cat')
                            }
                        })

                        elemNav.classList.add('current-cat')

                        const getCurrentCategory = document.querySelector('.content-cat').dataset.catslug

                        window.history.pushState(window.location.href, null, '/portfolio/'+getCurrentCategory);

                    }
                })

            })
        })

    }


    if(document.querySelector('.page-template-template-client')) {

        const elsClientsItems = document.querySelectorAll('.client-link')
        const elFirstChildClient = document.querySelector('.client-link')

        elFirstChildClient.classList.add('selected')
        document.querySelector(`[data-clientassocie="${elFirstChildClient.dataset.clientname}"]`).classList.add('is-visible')

        elsClientsItems.forEach(elem => {

            elem.addEventListener('mouseover', () => {

                elem.classList.add('selected')
                document.querySelector(`[data-clientassocie="${elem.dataset.clientname}"]`).classList.add('is-visible')

                if(elem != elFirstChildClient) {
                    elFirstChildClient.classList.remove('selected')
                    document.querySelector(`[data-clientassocie="${elFirstChildClient.dataset.clientname}"]`).classList.remove('is-visible')
                }

            })

            elem.addEventListener('mouseout', () => {
                elem.classList.remove('selected')
                document.querySelector(`[data-clientassocie="${elem.dataset.clientname}"]`).classList.remove('is-visible')

                elFirstChildClient.classList.add('selected')
                document.querySelector(`[data-clientassocie="${elFirstChildClient.dataset.clientname}"]`).classList.add('is-visible')
            })

            elem.addEventListener('click', () => {
                const actualSelected = document.querySelector('.client-link.selected')

                actualSelected.classList.remove('selected')
                elem.classList.add('selected')
            })
        })
    }

    /******* DISPLAY RESERVATION FORM ***/
    const elsReservationForm = document.querySelectorAll('.call-reservation')
    const elReservationBlock = document.querySelector('.reservation-block')

    elsReservationForm.forEach(elem => {

        elem.addEventListener('click', () => {
            elReservationBlock.classList.add('is-visible')
            if(elReservationBlock.classList.contains('is-not-visible')) {
                elReservationBlock.classList.remove('is-not-visible')
            }
        })

    })

});






// ------------------------------------
// Import CSS
// Import Scripts
// Import Images
// ------------------------------------


// ------------------------------------
// Import SCSS files
// ------------------------------------

import "../sass/main.scss";

// ------------------------------------
// Import scripts
// ------------------------------------

// Bootstrap JS
// import Base from 'bootstrap/js/dist/base-component';
// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
// import Dropdown from 'bootstrap/js/dist/dropdown';
//import 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Popover from 'bootstrap/js/dist/popover';
// import Scrollspy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
// import Tooltip from 'bootstrap/js/dist/tooltip';

// Sliders
//import Slick            from "slick-carousel/slick/slick";

// Scripts
// import  "./components/header";
import  "./components/booking";
//import Anchor           from "./components/scrollto";
//import SliderPost       from "./components/slider"



// ------------------------------------
// Import images
// ------------------------------------

//import "../img/icons/icon-facebook.svg";

